module.exports = __webpack_public_path__ + "static/20230619_233-8736c7fa1a93fd031dbad2a1c9adc576.jpg";